import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Pagination, CircularProgress, Button } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import {
  TextField,
  InputAdornment,
  Modal,
  Box,
  Typography,
} from '@mui/material';
import { Delete, Cancel } from '@mui/icons-material';

import ConfirmationModal from '../../../components/Modal';
import TDataGrid from '../../../components/Datagrid/Datagrid';
import { columns as Columns } from './constants/table_columns_data';
import service from './service';
import { useBoundStore } from '../../../stores';

const Assignments = () => {
  const textPool = useBoundStore((state) => state.textPool);
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const location = useLocation();

  const [filterData, setFilterData] = useState({ param: '' });
  const [sortModel, setSortModel] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [count, setCount] = useState(0);
  const [deleteItem, setDeleteItem] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [relOpen, setRelOpen] = useState(false);
  const [row, setRow] = useState({});
  const [relation, setRelation] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const paginationChange = (_, e_page) => setPage(e_page - 1);

  const handleDelete = async (row) => {
    setRow(row);
    setOpen(true);
  };

  const handleRelation = async (row) => {
    setRow(row);
    getDeviceVehicleRelation(row.device_Id);
    setRelOpen(true);
  };

  const columns = Columns(handleDelete, handleRelation);

  const deleteAssignment = async () => {
    const result = await service.deleteAssignment({
      id: row.id,
    });
    if (result?.status === 200 || result?.status === 204) {
      setOpen(false);
      toast.success('Atama başarıyla silindi.');
      getData();
    } else {
      toast.error('Atama silinirken bir hata oluştu.');
    }
  };

  async function getData() {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    const params = {
      ...filterData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getAssignmentsWithSearch(params);
    const data = result?.data?.content;
    setCount(result?.data?.totalPages);
    setDevices(data);
    setIsLoading(false);
  }

  useEffect(() => {
    setPage(0);
    getData();
  }, [filterData]);

  const filter = async () => {
    setPage(0);
    getData();
  };

  useEffect(() => {
    getData();
  }, [page, sortModel, location]);

  const handleFilterInput = (value) => {
    setFilterData({
      ...filterData, param
        : value
    });
  }

  return (
    <div className="p-3 m-3 flex flex-col justify-center items-center">
      <div className="w-max   max-lg:w-full p-3 m-3">
        <div className=" py-3 px-2 mx-3 my-2 flex flex-wrap justify-between max-md:justify-center gap-3 items-center">
          <span className="text-lg sm:text-2xl max-sm:text-center">
            Atamalar
          </span>
          <div className="mx-2 my-5 flex justify-between items-center">
            <div className="flex max-md:flex-wrap max-md:justify-center gap-2">
              <TextField
                size="small"
                placeholder="Arama"
                onChange={(e) => handleFilterInput(e.target.value)}
                value={filterData.param}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MATERIEL_ICONS.Search />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: '8px',
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Add />}
                onClick={() => toggleRightDrawer()}
                className="mx-2"
              >
                ATAMA EKLE
              </Button>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center w-[780px]">
            <CircularProgress className="users-list-circular-progress" />
          </div>
        ) : (
          <div className="w-max max-lg:w-full bg-white rounded-xl shadow-xl p-3 m-3">
            <TDataGrid
              rows={devices}
              columns={columns}
              sortModel={sortModel}
              setSortModel={setSortModel}
            />
            <div className="flex justify-center items-center p-3 m-3">
              <Pagination
                page={page + 1}
                onChange={paginationChange}
                count={count}
                color="primary"
                size="small"
              />
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        img="warning"
        open={open}
        handleClose={() => setOpen(false)}
        title={`${row?.deviceId?.imei ? row?.deviceId?.imei + " IMEI kodlu" : row?.id + " ID'li"} atamayı silmek üzeresiniz.`}
        onConfirm={deleteAssignment}
        confirmText="SİL"
        cancelText="İPTAL"
        confirmStartIcon={<Delete />}
        cancelStartIcon={<Cancel />}
        text="Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?"
      />
      {/* <ConfirmationModal
        img="warning"
        open={relOpen}
        handleClose={() => setRelOpen(false)}
        title={`${row?.device_Id} cihazının ${row?.vehicle_Id} aracı ile olan eşleşmesini kaldırmak üzeresiniz.`}
        onConfirm={deleteDeviceVehicleRelation}
        confirmText="KALDIR"
        cancelText="İPTAL"
        confirmStartIcon={<Delete />}
        cancelStartIcon={<Cancel />}
        text="Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?"
      /> */}
      {/* <MatchingModal
        modalOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
      /> */}
    </div>
  );
};

export default Assignments;
